import * as types from './action-types';

export function setRecaptchaStrategy(strategy) {
  return {type: types.SET_RECAPTCHA_STRATEGY, strategy};
}

export function setRecaptchaToken(token) {
  return {type: types.SET_RECAPTCHA_TOKEN, token};
}
